import { render, staticRenderFns } from "./ChatBitrix24Panel.vue?vue&type=template&id=db361f20&scoped=true&"
import script from "./ChatBitrix24Panel.vue?vue&type=script&lang=ts&"
export * from "./ChatBitrix24Panel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db361f20",
  null
  
)

export default component.exports